// 重新加载页面初始化token
export const INIT = 'INIT'

// 本地存储passport token
export const LOCALSTORAGE_PASSPORT_TOKEN_KEY = 'LOCALSTORAGE_PASSPORT_TOKEN_KEY'

// 更新passport token信息
export const PERSIST_PASSPORT_TOKEN = 'PERSIST_PASSPORT_TOKEN'

// 根据角色权限确定是否显示/隐藏某功能模块
export const UPDATE_SHOW_AUTHORITY = 'UPDATE_SHOW_AUTHORITY'

// 持久化上线状态
export const PERSIST_ACCEPT_STATUS = 'PERSIST_ACCEPT_STATUS'

// 设置视频客服在线状态
export const PERSIST_WEBRTC_STATUS = 'PERSIST_WEBRTC_STATUS'

// 持久化自动回复历史
export const QUERY_AUTO_REPLY = 'QUERY_AUTO_REPLY'

// 持久化自动回复
export const PERSIST_AUTO_REPLY = 'PERSIST_AUTO_REPLY'

// 删除持久化自动回复
export const DELETE_AUTO_REPLY = 'DELETE_AUTO_REPLY'

// 持久化user info
export const PERSIST_USER_INFO = 'PERSIST_USER_INFO'

// 持久化queues
export const PERSIST_USER_QUEUES = 'PERSIST_USER_QUEUES'

// 持久化一条queue
export const ADD_USER_QUEUE = 'ADD_USER_QUEUE'

// 删除一条queue
export const ACCEPT_USER_QUEUE = 'ACCEPT_USER_QUEUE'
export const IGNORE_USER_QUEUE = 'IGNORE_USER_QUEUE'

// 持久化用户所属threads
export const PERSIST_USER_THREADS = 'PERSIST_USER_THREADS'

// 初始化，不增加未读数目
export const INIT_USER_THREAD = 'INIT_USER_THREAD'

// 清理用户会话
export const CLEAR_USER_THREADS = 'CLEAR_USER_THREADS'

// 插入一条会话
export const INSERT_USER_THREAD = 'INSERT_USER_THREAD'

// 持久化一条会话thread
export const ADD_USER_THREAD = 'ADD_USER_THREAD'

// 关闭会话
export const CLOSE_USER_THREAD = 'CLOSE_USER_THREAD'

// 删除会话
export const REMOVE_USER_THREAD = 'REMOVE_USER_THREAD'

// 重新开始会话
export const RESTART_USER_THREAD = 'RESTART_USER_THREAD'

// 设置当前会话
export const UPDATE_CURRENT_THREAD = 'UPDATE_CURRENT_THREAD'

// 持久化当前输入框草稿
export const PERSIST_THREAD_DRAFT = 'PERSIST_THREAD_DRAFT'

// 会话置顶
export const MARK_TOP_THREAD = 'MARK_TOP_THREAD'

// 取消会话置顶
export const UNMARK_TOP_THREAD = 'UNMARK_TOP_THREAD'

// 会话免打扰
export const MARK_NODISTURB_THREAD = 'MARK_NODISTURB_THREAD'

// 取消会话免打扰
export const UNMARK_NODISTURB_THREAD = 'UNMARK_NODISTURB_THREAD'

// 会话未读
export const MARK_UNREAD_THREAD = 'MARK_UNREAD_THREAD'

// 取消会话未读
export const UNMARK_UNREAD_THREAD = 'UNMARK_UNREAD_THREAD'

// 星标/取消星标会话
export const MARK_STAR_THREAD = 'MARK_STAR_THREAD'

// 持久化机器人会话 - 进行中
export const PERSIST_ROBOT_THREAD_ONGOING = 'PERSIST_ROBOT_THREAD_ONGOING'
export const REMOVE_ROBOT_THREAD_ONGOING = 'REMOVE_ROBOT_THREAD_ONGOING'

// 持久化机器人会话 - 已结束
export const PERSIST_ROBOT_THREAD_CLOSED = 'PERSIST_ROBOT_THREAD_CLOSED'

// 更新当前会话昵称
export const UPDATE_CURRENT_THREAD_NICKNAME = 'UPDATE_CURRENT_THREAD_NICKNAME'

// 清空当前会话
export const CLEAR_CURRENT_THREAD = 'CLEAR_CURRENT_THREAD'

// 更新未读数目
export const UPDATE_THREAD_UNREAD_COUNT = 'UPDATE_THREAD_UNREAD_COUNT'

// 持久化同事列表
export const PERSIST_USER_CONTACTS = 'PERSIST_USER_CONTACTS'

// 设置当前联系人
export const UPDATE_CURRENT_CONTACT = 'UPDATE_CURRENT_CONTACT'

// 设置当前群组
export const UPDATE_CURRENT_GROUP = 'UPDATE_CURRENT_GROUP'

// 设置当前排队
export const UPDATE_CURRENT_QUEUE = 'UPDATE_CURRENT_QUEUE'

export const UPDATE_CURRENT_BROWSE = 'UPDATE_CURRENT_BROWSE'

// 设置当前会话类型
export const UPDATE_CURRENT_CHAT_TYPE = 'UPDATE_CURRENT_CHAT_TYPE'

// 更新当前customer crm信息
export const UPDATE_CURRENT_CUSTOMER_INFO = 'UPDATE_CURRENT_CUSTOMER_INFO'

export const CLEAR_CURRENT_CUSTOMER_INFO = 'CLEAR_CURRENT_CUSTOMER_INFO'
// 缓存本地customer info
export const ADD_CUSTOMER_INFO = 'ADD_CUSTOMER_INFO'

// 客户持久化
export const PERSIST_CUSTOMERS = 'PERSIST_CUSTOMERS'

// 更新当前会话内容
export const UPDATE_THREAD_CONTENT = 'UPDATE_THREAD_CONTENT'

// 更新会话昵称
export const UPDATE_THREAD_NICKNAME = 'UPDATE_THREAD_NICKNAME'

// 持久化用户所属workgroups
export const PERSIST_USER_WORKGROUPS = 'PERSIST_USER_WORKGROUPS'

// 持久化一条工作组workgroup
export const ADD_USER_WORKGROUP = 'ADD_USER_WORKGROUP'

// 持久化一条工作组workgroup
export const UPDATE_USER_WORKGROUP = 'UPDATE_USER_WORKGROUP'

// 持久化一条工作组workgroup
export const DELETE_USER_WORKGROUP = 'DELETE_USER_WORKGROUP'

// 持久化用户所属groups
export const PERSIST_USER_GROUPS = 'PERSIST_USER_GROUPS'

// 持久化一条工作组group
export const ADD_USER_GROUP = 'ADD_USER_GROUP'

// 持久化一条工作组group
export const UPDATE_USER_GROUP = 'UPDATE_USER_GROUP'

// 持久化一条工作组group
export const DELETE_USER_GROUP = 'DELETE_USER_GROUP'

// 持久化用户消息messages
export const PERSIST_USER_MESSAGES = 'PERSIST_USER_MESSAGES'

// 持久化一条消息message
export const ADD_USER_MESSAGE = 'ADD_USER_MESSAGE'

//
export const ADD_PROTOBUF_MESSAGE = 'ADD_PROTOBUF_MESSAGE'
// 更新一条消息message
export const UPDATE_USER_MESSAGE = 'UPDATE_USER_MESSAGE'
// 删除一条消息message
export const DELETE_USER_MESSAGE = 'DELETE_USER_MESSAGE'
// 更新消息：增加翻译信息
export const UPDATE_MESSAGE_ADD_TRANSLATE = 'UPDATE_MESSAGE_ADD_TRANSLATE'
//
export const UPDATE_THREAD_DELAY = 'UPDATE_THREAD_DELAY'
// 持久化商品消息
export const PERSIST_COMMODITY_MESSAGES = 'PERSIST_COMMODITY_MESSAGES'
// 清空商品消息
export const CLEAR_COMMODITY_MESSAGES = 'CLEAR_COMMODITY_MESSAGES'

// 浏览中访客操作相关
export const PERSIST_USER_BROWSES = 'PERSIST_USER_BROWSES'

export const ADD_USER_BROWSE = 'ADD_USER_BROWSE'

export const DELETE_USER_BROWSE = 'DELETE_USER_BROWSE'

export const PERSIST_NOTICE_BROWSES = 'PERSIST_NOTICE_BROWSES'

export const UPDATE_CURRENT_NOTICE_BROWSES = 'UPDATE_CURRENT_NOTICE_BROWSES'

// 通知
export const ADD_NOTICE = 'ADD_NOTICE'

export const CLEAR_NOTICES = 'CLEAR_NOTICES'

export const PERSIST_NOTICES = 'PERSIST_NOTICES'

export const UPDATE_CURRENT_NOTICE = 'UPDATE_CURRENT_NOTICE'

// 待办任务
export const ADD_TODO = 'ADD_TODO'

export const CLEAR_TODOS = 'CLEAR_TODOS'

export const PERSIST_TODOS = 'PERSIST_TODOS'

export const UPDATE_CURRENT_TODO = 'UPDATE_CURRENT_TODO'

export const UPDATE_TODO = 'UPDATE_TODO'

export const DELETE_TODO = 'DELETE_TODO'

// 更新链接状态
export const UPDATE_USER_CONNECTION = 'UPDATE_USER_CONNECTION'

export const UPDATE_NETWORK_CONNECTION = 'UPDATE_NETWORK_CONNECTION'

export const UPDATE_UNREAD_MESSAGE_STATUS = 'UPDATE_UNREAD_MESSAGE_STATUS'

// 持久化管理员threads
export const PERSIST_THREADS = 'PERSIST_THREADS'

export const ADD_THREAD = 'ADD_THREAD'

export const PERSIST_HISTORIES = 'PERSIST_HISTORIES'

export const CLEAR_HISTORY_RECORDS = 'CLEAR_HISTORY_RECORDS'

export const PERSIST_HISTORY_RECORDS = 'PERSIST_HISTORY_RECORDS'

export const PERSIST_SEARCH_THREAD = 'PERSIST_SEARCH_THREAD'

export const PERSIST_SEARCH_THREADS = 'PERSIST_SEARCH_THREADS'

export const PERSIST_RATES = 'PERSIST_RATES'
// 持久化在线状态
export const PERSIST_STATUSES = 'PERSIST_STATUSES'

export const PERSIST_QUEUES = 'PERSIST_QUEUES'

export const PERSIST_BROWSES = 'PERSIST_BROWSES'

export const PERSIST_MONITORS = 'PERSIST_MONITORS'

export const REMOVE_MONITORS = 'REMOVE_MONITORS'

export const PERSIST_QUALITIES = 'PERSIST_QUALITIES'

// 快捷回复
export const PERSIST_CUWS = 'PERSIST_CUWS'

export const ADD_CUW = 'ADD_CUW'

export const UPDATE_CUW = 'UPDATE_CUW'

export const DELETE_CUW = 'DELETE_CUW'

export const UPDATE_COMPANY_CURRENT_CUW_CATEGORY_ID = 'UPDATE_COMPANY_CURRENT_CUW_CATEGORY_ID'

// 持久化用户设备指纹信息
export const PERSIST_USER_FINGERPRINTS = 'PERSIST_USER_FINGERPRINTS'

// 持久化访客个人信息
export const PERSIST_VISITOR_PROFILE = 'PERSIST_VISITOR_PROFILE'

export const ADD_USER_FINGERPRINT = 'ADD_USER_FINGERPRINT'
// 持久化客服
export const PERSIST_AGENTS = 'PERSIST_AGENTS'
//
export const PERSIST_ONLINE_AGENTS = 'PERSIST_ONLINE_AGENTS'
// 添加客服
export const ADD_AGENT = 'ADD_AGENT'
//
export const UPDATE_AGENT = 'UPDATE_AGENT'
//
export const DELETE_AGENT = 'DELETE_AGENT'
// 
export const PERSIST_VISITOR_UNIAPP = 'PERSIST_VISITOR_UNIAPP'
// 
export const PERSIST_VISITOR_FLUTTER = 'PERSIST_VISITOR_FLUTTER'
// 
export const PERSIST_VISITOR_ANDROID = 'PERSIST_VISITOR_ANDROID'
// 
export const PERSIST_VISITOR_IOS = 'PERSIST_VISITOR_IOS'
// 
export const PERSIST_VISITOR_WECHAT = 'PERSIST_VISITOR_WECHAT'

// 持久化管理员workgroups
export const PERSIST_WORKGROUPS = 'PERSIST_WORKGROUPS'

export const ADD_WORKGROUP = 'ADD_WORKGROUP'
//
export const UPDATE_WORKGROUP = 'UPDATE_WORKGROUP'
//
export const DELETE_WORKGROUP = 'DELETE_WORKGROUP'
// 省市
export const PERSIST_REGIONS = 'PERSIST_REGIONS'
// 持久化分公司
export const PERSIST_COMPANIES = 'PERSIST_COMPANIES'
// 添加
export const ADD_COMPANY = 'ADD_COMPANY'
// 更新
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
// 删除
export const DELETE_COMPANY = 'DELETE_COMPANY'
// 持久化roles
export const PERSIST_ROLES = 'PERSIST_ROLES'

// 持久化消息messages
export const PERSIST_MESSAGES_ARCHIVE = 'PERSIST_MESSAGES_ARCHIVE'
export const PERSIST_MESSAGES = 'PERSIST_MESSAGES'

export const ADD_MESSAGE = 'ADD_MESSAGE'

export const UPDATE_LOAD_MESSAGE_PAGE = 'UPDATE_LOAD_MESSAGE_PAGE'
//
export const PERSIST_USER_TAGS = 'PERSIST_USER_TAGS'
//
export const PERSIST_THREAD_TAGS = 'PERSIST_THREAD_TAGS'
//
export const ADD_USER_TAG = 'ADD_USER_TAG'
//
export const DELETE_USER_TAG = 'DELETE_USER_TAG'

// 分类: 快捷回复、智能问答、帮助中心
export const PERSIST_CATEGORIES = 'PERSIST_CATEGORIES'
//
export const ADD_CATEGORY = 'ADD_CATEGORY'
//
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
//
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
//
export const PERSIST_ROBOT_ANSWERS = 'PERSIST_ROBOT_ANSWERS'
//
export const ADD_ROBOT_ANSWER = 'ADD_ROBOT_ANSWER'
//
export const UPDATE_ROBOT_ANSWER = 'UPDATE_ROBOT_ANSWER'
//
export const DELETE_ROBOT_ANSWER = 'DELETE_ROBOT_ANSWER'
//
export const PERSIST_ROBOT_SYNONYMS = 'PERSIST_ROBOT_SYNONYMS'
//
export const UPDATE_ROBOT_SYNONYM = 'UPDATE_ROBOT_SYNONYM'
//
export const ADD_ROBOT_SYNONYM = 'ADD_ROBOT_SYNONYM'
//
export const DELETE_ROBOT_SYNONYM = 'DELETE_ROBOT_SYNONYM'
//
export const PERSIST_TABOOS = 'PERSIST_TABOOS'
//
// export const UPDATE_TABOO = 'UPDATE_TABOO'
//
// export const ADD_TABOO = 'ADD_TABOO'
//
// export const DELETE_TABOO = 'DELETE_TABOO'
//
export const PERSIST_FILTER_WORKGROUPS = 'PERSIST_FILTER_WORKGROUPS'
//
export const PERSIST_FILTER_WORKGROUP_MEMBERS = 'PERSIST_FILTER_WORKGROUP_MEMBERS'
// 留言持久化操作
export const PERSIST_LEAVE_MESSAGES = 'PERSIST_LEAVE_MESSAGES'
//
export const UPDATE_LEAVE_MESSAGE = 'UPDATE_LEAVE_MESSAGE'
//
export const DELETE_LEAVE_MESSAGE = 'DELETE_LEAVE_MESSAGE'
//
export const PERSIST_SUPPORT_ARTICLES = 'PERSIST_SUPPORT_ARTICLES'
//
export const ADD_SUPPORT_ARTICLE = 'ADD_SUPPORT_ARTICLE'
//
export const UPDATE_SUPPORT_ARTICLE = 'UPDATE_SUPPORT_ARTICLE'
//
export const DELETE_SUPPORT_ARTICLE = 'DELETE_SUPPORT_ARTICLE'
// 持久化统计数据
export const PERSIST_STATISTICS_AGENT_TODAY = 'PERSIST_STATISTICS_AGENT_TODAY'
//
export const PERSIST_STATISTICS_AGENT_UID_TODAY = 'PERSIST_STATISTICS_AGENT_UID_TODAY'
//
export const PERSIST_STATISTICS = 'PERSIST_STATISTICS'
// 统计数据详情
export const PERSIST_STATISTIC_DETAILS = 'PERSIST_STATISTIC_DETAILS'
//
export const PERSIST_STATISTICS_THREADS = 'PERSIST_STATISTICS_THREADS'
//
export const PERSIST_STATISTICS_RATES = 'PERSIST_STATISTICS_RATES'
//
export const PERSIST_WEBS = 'PERSIST_WEBS'
//
export const ADD_WEB = 'ADD_WEB'
//
export const UPDATE_WEB = 'UPDATE_WEB'
//
export const DELETE_WEB = 'DELETE_WEB'
//
export const PERSIST_APPS = 'PERSIST_APPS'
//
export const ADD_APP = 'ADD_APP'
//
export const UPDATE_APP = 'UPDATE_APP'
//
export const DELETE_APP = 'DELETE_APP'
//
export const PERSIST_MPS = 'PERSIST_MPS'
//
export const ADD_MP = 'ADD_MP'
//
export const UPDATE_MP = 'UPDATE_MP'
//
export const DELETE_MP = 'DELETE_MP'
//
export const PERSIST_MINIS = 'PERSIST_MINIS'
//
export const ADD_MINI = 'ADD_MINI'
//
export const UPDATE_MINI = 'UPDATE_MINI'
//
export const DELETE_MINI = 'DELETE_MINI'
// 添加订阅
export const SUBSCRIBE_TOPIC = 'SUBSCRIBE_TOPIC'
// 取消订阅
export const UNSUBSCRIBE_TOPIC = 'UNSUBSCRIBE_TOPIC'
// 清空订阅
export const CLEAR_TOPIC = 'CLEAR_TOPIC'
// LOGOUT
export const LOGOUT = 'LOGOUT'
// 修改当前主view
export const CHANGE_CURRENT_MAIN_VIEW = 'CHANGE_CURRENT_MAIN_VIEW'
// 修改边栏颜色
export const CHANGE_SIDEBAR_COLOR = 'CHANGE_SIDEBAR_COLOR'
// 添加工单
export const ADD_TICKET = 'ADD_TICKET'
export const ADD_FOR_ME_TO_REPLY_TICKET = 'ADD_FOR_ME_TO_REPLY_TICKET'
export const ADD_TO_BE_REPLIED_TICKET = 'ADD_TO_BE_REPLIED_TICKET'
export const ADD_DONE_TICKET = 'ADD_DONE_TICKET'
export const ADD_IGNORED_TICKET = 'ADD_IGNORED_TICKET'
export const ADD_CLOSED_TICKET = 'ADD_CLOSED_TICKET'
export const DO_IGNORE_TICKET = 'DO_IGNORE_TICKET'
export const DO_DONE_TICKET = 'DO_DONE_TICKET'
// 删除工单
export const REMOVE_TICKET = 'REMOVE_TICKET'
// 更新工单
export const UPDATE_TICKET = 'UPDATE_TICKET'
// 清空工单
export const CLEAR_TICKETS = 'CLEAR_TICKETS'
// 设置当前工单
export const UPDATE_CURRENT_TICKET = 'UPDATE_CURRENT_TICKET'
// 设置当前在线访客
export const UPDATE_CURRENT_ONLINE_USER = 'UPDATE_CURRENT_ONLINE_USER'
// 设置当前访客浏览记录
export const UPDATE_BROWSE_RECORDS = 'UPDATE_BROWSE_RECORDS'
// 设置当前监控会话
export const UPDATE_CURRENT_MONITOR_THREAD = 'UPDATE_CURRENT_MONITOR_THREAD'
// 设置是否显示底部统计数据
export const UPDATE_SHOW_BOTTOM_STATISTICS = 'UPDATE_SHOW_BOTTOM_STATISTICS'
// 设置是否显示超时提醒
export const UPDATE_SHOW_OUT_OF_TIME = 'UPDATE_SHOW_OUT_OF_TIME'
// 设置是否显示输入联想
export const UPDATE_SHOW_INPUT_TIPS = 'UPDATE_SHOW_INPUT_TIPS'
// 设置是否检测是否绑定公众号
export const UPDATE_QUERY_MPQRCODE_URL = 'UPDATE_QUERY_MPQRCODE_URL'
// 是否显示网络断开恢复提示
export const UPDATE_SHOW_NETWORK_STATUS = 'UPDATE_SHOW_NETWORK_STATUS'
// 设置视频客服状态
export const UPDATE_WEBRTC_STARTED = 'UPDATE_WEBRTC_STARTED'
// 持久化黑名单
export const PERSIST_BLOCKS = 'PERSIST_BLOCKS'
// 更新当前黑名单用户
export const UPDATE_CURRENT_BLOCK = 'UPDATE_CURRENT_BLOCK'
// 取消拉黑
export const REMOVE_CURRENT_BLOCK = 'REMOVE_CURRENT_BLOCK'
// 持久化会话小结
export const PERSIST_SUMMARIES = 'PERSIST_SUMMARIES'
// 持久化意见反馈
export const PERSIST_FEEDBACKS = 'PERSIST_FEEDBACKS'
// 持久化在线访客
export const PERSIST_ONLINE_USERS = 'PERSIST_ONLINE_USERS'
// 持久化表情
export const PERSIST_SELF_EMOJIS = 'PERSIST_SELF_EMOJIS'
// 添加表情
export const ADD_SELF_EMOJIS = 'ADD_SELF_EMOJIS'
// 更新表情
export const UPDATE_SELF_EMOJIS = 'UPDATE_SELF_EMOJIS'
// 删除表情
export const DELETE_SELF_EMOJIS = 'DELETE_SELF_EMOJIS'
// 持久化图片
export const PERSIST_SELF_IMAGES = 'PERSIST_SELF_IMAGES'
// 添加图片
export const ADD_SELF_IMAGES = 'ADD_SELF_IMAGES'
// 更新图片
export const UPDATE_SELF_IMAGES = 'UPDATE_SELF_IMAGES'
// 删除图片
export const DELETE_SELF_IMAGES = 'DELETE_SELF_IMAGES'
// 持久化文件
export const PERSIST_SELF_FILES = 'PERSIST_SELF_FILES'
// 添加文件
export const ADD_SELF_FILES = 'ADD_SELF_FILES'
// 更新文件
export const UPDATE_SELF_FILES = 'UPDATE_SELF_FILES'
// 删除文件
export const DELETE_SELF_FILES = 'DELETE_SELF_FILES'
// 设置右侧当前tab
export const UPDATE_RIGHT_ACTIVE_TAB = 'UPDATE_RIGHT_ACTIVE_TAB'
// 用户是否绑定公众号
export const IS_WECHAT_MP_BINDED = 'IS_WECHAT_MP_BINDED'
export const UPDATE_WECHAT_MP_BINDED = 'UPDATE_WECHAT_MP_BINDED'
// 更新微信公众号推送状态
export const UPDATE_WECHAT_MP_PUSH_ENABLED = 'UPDATE_WECHAT_MP_PUSH_ENABLED'
// 设置当前会话URL
export const UPDATE_CURRENT_THREAD_URL = 'UPDATE_CURRENT_THREAD_URL'